import Residency from './Residency'

export default Residency